"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourceUpload = exports.resourcePut = exports.resourceList = exports.resourceDelete = exports.resourceAdd = exports.placedTop = exports.getPeMajorInfoById = exports.courseList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 专业资源库管理 根据id获取详情
var getPeMajorInfoById = exports.getPeMajorInfoById = function getPeMajorInfoById(data) {
  return _api.default.request({
    url: '/major/info/getPeMajorInfoById',
    method: 'post',
    data: data
  });
};
// 专业资源库管理 分页查询
var resourceList = exports.resourceList = function resourceList(data) {
  return _api.default.request({
    url: '/major/info/pageList',
    method: 'post',
    data: data
  });
};

// 专业资源库管理 新增
var resourceAdd = exports.resourceAdd = function resourceAdd(data) {
  return _api.default.request({
    url: '/major/info/save',
    method: 'post',
    data: data
  });
};

// 专业资源库管理 编辑
var resourceUpload = exports.resourceUpload = function resourceUpload(data) {
  return _api.default.request({
    url: '/major/info/updateInfo',
    method: 'post',
    data: data
  });
};

// 专业资源库管理 删除
var resourceDelete = exports.resourceDelete = function resourceDelete(data) {
  return _api.default.request({
    url: '/major/info/delete',
    method: 'get',
    params: data
  });
};

// 专业资源库管理 上下架
var resourcePut = exports.resourcePut = function resourcePut(data) {
  return _api.default.request({
    url: '/major/info/updateStateBatch',
    method: 'post',
    data: data
  });
};

// 课程来源 查询全部
var courseList = exports.courseList = function courseList(data) {
  return _api.default.request({
    url: '/courseSource/getListAll',
    method: 'post',
    data: data
  });
};

// 置顶专业资源库
// /major/info/placedTop?id=#{id}
var placedTop = exports.placedTop = function placedTop(data) {
  return _api.default.request({
    url: '/major/info/placedTop' + jsonjoin(data),
    method: 'get',
    data: data
  });
};
function jsonjoin(data) {
  var str = '?';
  for (var key in data) {
    str += key + '=' + data[key] + '&';
  }
  return str.substring(0, str.length - 1);
}